import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.LanguageFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'language'
  facetName: 'language'
  selectAll: true

  getAppliedValues: ->
    return @searchQuery.get('languages')

  addFilter: (value) ->
    @searchQuery.addLanguage(value)
